import { LUX_PLUS_TOURS_CAMPAIGN } from 'luxPlus/constants/base'

/**
 * Banner elements that can be hidden on specific routes.
 */
export type HideableBanner =
  | 'headerTopBanners'
  | 'notificationBanner'
  | 'notificationBannerV3'
  | 'loyaltyUpgradeBanner'
  | 'appInstallBanner'
  | 'luxPlusGiftCardBanner'
  | 'luxPlusToursOfferBanner'
  | 'siteTakeoverPageBanner'

/**
 * Central route visibility configuration for banners.
 * Routes support wildcards using `/*` suffix for section-wide rules.
 * More specific routes take precedence over wildcards.
 */
export const BANNER_ROUTE_CONFIG: Record<string, Array<HideableBanner>> = {
  '/:regionCode': [
    ...(LUX_PLUS_TOURS_CAMPAIGN.SHOULD_OVERRIDE_LAB_CAMPAIGN ? [] : ['luxPlusToursOfferBanner'] as const),
  ],
  '/:regionCode/le-wrapped-2025': [
    'headerTopBanners',
    'notificationBanner',
    'notificationBannerV3',
    'loyaltyUpgradeBanner',
    'appInstallBanner',
  ],
  '/:regionCode/le-wrapped-2025/:uuid': [
    'headerTopBanners',
    'notificationBanner',
    'notificationBannerV3',
    'loyaltyUpgradeBanner',
    'appInstallBanner',
  ],
  '/:regionCode/trip-planner/generate-trip': [
    'headerTopBanners',
    'notificationBanner',
    'notificationBannerV3',
    'loyaltyUpgradeBanner',
    'appInstallBanner',
    'siteTakeoverPageBanner',
    'luxPlusToursOfferBanner',
  ],
  '/:regionCode/trip-planner/chat-trip-planner/:tripId?': [
    'headerTopBanners',
    'notificationBanner',
    'notificationBannerV3',
    'loyaltyUpgradeBanner',
    'appInstallBanner',
    'luxPlusToursOfferBanner',
  ],
  '/:regionCode/trip-planner/*': [
    'headerTopBanners',
    'notificationBanner',
    'notificationBannerV3',
    'loyaltyUpgradeBanner',
    'appInstallBanner',
    'luxPlusToursOfferBanner',
  ],
  '/:regionCode/checkout/*': [
    'notificationBanner',
    'appInstallBanner',
    'siteTakeoverPageBanner',
    'luxPlusToursOfferBanner',
  ],
  '/:regionCode/support/*': [
    'headerTopBanners',
    'notificationBanner',
    'appInstallBanner',
  ],
  '/:regionCode/search/*': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/metasearch/*': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/account/*': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/booking/*': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/bb/booking/*': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/campaign/*': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/triple-points': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/double-status-credits': [
    'siteTakeoverPageBanner',
  ],
  '/:regionCode/campaign/ski': [
    'appInstallBanner',
  ],
  '/:regionCode/campaign/maldives-direct': [
    'appInstallBanner',
  ],
  '/:regionCode/pay/*': [
    'appInstallBanner',
  ],
  '/:regionCode/tour/*': [
    'appInstallBanner',
  ],
  '/:regionCode/tours/*': [
    'appInstallBanner',
  ],
  '/:regionCode/search/tours/*': [
    'appInstallBanner',
  ],
  '/:regionCode/cruises/*': [
    'appInstallBanner',
  ],
  '/:regionCode/search/cruises/*': [
    'appInstallBanner',
  ],
}
